'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { useFeatureFlags } from '../hooks/useFeatureFlags'

/* PERF: the AI command center (and its SSE connection) loads after the main
   thread is idle — it was hydrating eagerly inside every page's critical path */
const GlobalAICommandCenter = dynamic(() => import('./GlobalAICommandCenter'), {
  ssr: false,
  loading: () => null,
})

const SuperAppShell = dynamic(() => import('./SuperAppShell'), {
  ssr: false,
  loading: () => null,
})

const BottomNav = dynamic(() => import('./BottomNav'), {
  ssr: false,
  loading: () => null,
})

const ProductAnalyticsTracker = dynamic(() => import('./ProductAnalyticsTracker'), {
  ssr: false,
  loading: () => null,
})

export default function GlobalClientRuntime() {
  const { isFeatureSettingEnabled } = useFeatureFlags()
  const [idle, setIdle] = useState(false)

  useEffect(() => {
    const ric = (window as any).requestIdleCallback || ((cb: () => void) => window.setTimeout(cb, 1500))
    const id = ric(() => setIdle(true))
    return () => {
      const cancel = (window as any).cancelIdleCallback || window.clearTimeout
      cancel(id)
    }
  }, [])

  const showShell = isFeatureSettingEnabled('shellComplexity', 'publicVisible')
  const showCommand = idle && isFeatureSettingEnabled('aiAssistant', 'publicVisible') && isFeatureSettingEnabled('search', 'publicVisible')

  return (
    <>
      <ProductAnalyticsTracker />
      {showShell && <SuperAppShell />}
      {showCommand && <GlobalAICommandCenter />}
      <BottomNav />
    </>
  )
}
